import React, { useEffect, useState } from "react";
import { EditFontSize } from "./components/EditFontSize";


export const EditTheme = () => {
  return (
    <>
      <EditFontSize />
    </>
  )
};
